export default __webpack_public_path__ + "static/media/vehicle_active_trunk.f8fec1e9.svg";